import * as types from '../actions/winner-actions';

const initialState = {
	WEEKLY: [],
	TRIMESTRIAL: [],
	MONTHLY: []
};

const winnerReducer = function (state = initialState, action) {

	switch (action.type) {
		case types.RESET_VALUES:
			return Object.assign({}, state, initialState);
			break;

		case types.GET_WINNER_SUCCESS:

			let WEEKLY = [];
			let TRIMESTRIAL = [];
			let MONTHLY = [];

			for (let winner of action.winner) {

				if (winner.nextLottery) {
					var dt = winner.nextLottery.split("T")[0].split('-');
					winner.nextLottery = dt[2] + '/' + dt[1] + '/' + dt[0];
				}

				if (winner.date) {
					var dt = winner.date.split("T")[0].split('-');
					winner.date = dt[2] + '/' + dt[1] + '/' + dt[0];
				}

				if (winner.type === "WEEKLY")
					WEEKLY.push(winner);
				else if (winner.type === "TRIMESTRIAL")
					TRIMESTRIAL.push(winner);
				else if (winner.type === 'MONTHLY')
					MONTHLY.push(winner)
			}

			return Object.assign({}, state, {
				WEEKLY,
				TRIMESTRIAL,
				MONTHLY
			});
			break;
	}

	return state;
};

export default winnerReducer;


// WEBPACK FOOTER //
// ./src/reducers/winner-reducer.js